import { createMCQAnswersTable } from './utils';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import { learnosityReportByUsers } from './progressHelpers';

const getItemByReference = (items, reference) =>
  items.find((item) => item.reference === reference);

export default function getResponsesByUser(
  responseAnalysisReports,
  learnosityItems,
) {
  const responsesByUser = {};
  (responseAnalysisReports || []).forEach((report) => {
    if (report.data && report.data.questions && report.data.sessions) {
      const questionsByReference = report.data.questions.reduce(
        (acc, question) => {
          const item = getItemByReference(learnosityItems, question.item_id);
          let options;

          if (item) {
            const firstQuestionOnItem = item.questions[0];
            options = firstQuestionOnItem && firstQuestionOnItem.options;
          }

          acc[question.question_id] = {
            ...question,
            answersTable: options
              ? createMCQAnswersTable(options.map((option) => option.value))
              : {},
          };

          return acc;
        },
        {},
      );

      Object.values(report.data.sessions).forEach((session) => {
        const userId = session.user_id;
        if (!responsesByUser[userId]) {
          responsesByUser[userId] = {};
        }

        const questionPermutationIndexes = session.responses.questions.reduce(
          (acc, questionResponse) => {
            acc[questionResponse.question_id] =
              questionResponse.permutation_idx;
            return acc;
          },
          {},
        );

        report.data.items.forEach((item) => {
          // For now we allow only one question per item, so we are only interested in the response for the first (and the only) question.
          const questionReference = item.questions[0];
          const question = questionsByReference[questionReference];

          const { response } =
            question.permutations[
              questionPermutationIndexes[questionReference]
            ] || {};

          if (response && response.value) {
            if (response.type === 'array') {
              responsesByUser[userId][item.item_id] = response.value
                .map((answer) => question.answersTable[answer] || answer)
                .sort();
            } else if (response.type === 'object') {
              responsesByUser[userId][item.item_id] = [response.value.score];
            } else {
              responsesByUser[userId][item.item_id] = response.value;
            }
          }
        });
      });
    }
  });

  return responsesByUser;
}

export const getMCQScoreByUsers = (resultsByItem, questions) => {
  const mcqScoresByUsers = {};

  if (!resultsByItem.length) {
    return mcqScoresByUsers;
  }

  const activity = resultsByItem[0].data;

  if (isEmpty(activity)) {
    return mcqScoresByUsers;
  }

  const activityId = Object.keys(activity)[0];
  const users = get(activity, `${activityId}.users`);
  const userIds = Object.keys(users);
  const mcqQuestionReferences = [];
  questions.forEach(
    (question) =>
      question.type === 'MultipleChoiceQuestion' &&
      mcqQuestionReferences.push(question.learnosityItemReference),
  );
  userIds.forEach((userId) => {
    const userResponses = users[userId].items;
    let score = 0;
    let maxScore = 0;
    const allAttempts = [];
    Object.keys(userResponses).forEach((responseKey) => {
      if (mcqQuestionReferences.includes(responseKey)) {
        maxScore += userResponses[responseKey].max_score;
        score +=
          userResponses[responseKey].attempted === false
            ? 0
            : userResponses[responseKey].score;
        allAttempts.push(userResponses[responseKey].attempted);
      }
    });
    mcqScoresByUsers[userId] = { score, maxScore, allAttempts };
  });
  return mcqScoresByUsers;
};

export const getFRQScoreByUsers = (results) => {
  const resultsByUsers = learnosityReportByUsers(results);
  const frqScoresByUser = {};

  Object.keys(resultsByUsers).map((userId) => {
    const questions = resultsByUsers[userId].items;
    const score = Object.values(questions).reduce(
      (score, question) => score + question.score,
      0,
    );
    const maxScore = Object.values(questions).reduce(
      (a, question) => a + question.max_score,
      0,
    );
    frqScoresByUser[userId] = { score, maxScore };
  });

  return frqScoresByUser;
};
